import {
  docType,
  MESSAGE_CONTENT_DOCUMENT_TYPE,
} from "@home-health-notify/domain";
import defaultIcon from "../../../../assets/images/document/DEFAULT.svg";
import docIcon from "../../../../assets/images/document/DOC.svg";
import pdfIcon from "../../../../assets/images/document/PDF.svg";
import excelIcon from "../../../../assets/images/document/XLS.svg";
import { DocBox } from "./MediaDocumentInfo.style";

const DocumentThumbBox = ({
  fileName,
  url,
  iconWidth,
  padding,
}: {
  fileName: string;
  url: string;
  iconWidth?: number;
  padding?: number | string;
}) => {
  const documentType = docType(url);
  let iconPath = () => {
    switch (documentType) {
      case MESSAGE_CONTENT_DOCUMENT_TYPE.PDF:
        return pdfIcon;
      case MESSAGE_CONTENT_DOCUMENT_TYPE.DOC:
        return docIcon;
      case MESSAGE_CONTENT_DOCUMENT_TYPE.XLS:
        return excelIcon;
      default:
        return defaultIcon;
    }
  };
  return (
    <DocBox sx={padding !== undefined ? { padding } : undefined}>
      <img width={iconWidth || "100%"} src={iconPath()} alt={fileName}></img>
    </DocBox>
  );
};

export default DocumentThumbBox;
